import { useApiFpCartRequestCache } from '@hooks-api/fortune/useApiFpCartRequestCache'
import { type CampaignCalculateRequest } from '@hooks-api/types/apiRequest'
import { create } from 'zustand'
import { type FpB2bCartValues } from '../types'
import { Platform } from './fp-b2b/store-map'
import { useFpB2bCartService } from './fp-b2b/use-fp-b2b-cart-service'

export const useFpMerchantSyncCartSessionStore = create<{
  hasFinishedSyncCartSession: boolean
  setHasFinishedSyncCartSession: (value: boolean) => void
}>()(set => ({
  hasFinishedSyncCartSession: false,
  setHasFinishedSyncCartSession: (value: boolean) => set({ hasFinishedSyncCartSession: value }),
}))

export interface UseFpMerchantSyncCartSessionToStoreProps {
  campaignCode: string | undefined
  campaignId: number | null
}

export const useFpMerchantSyncCartSessionToStore = (args: UseFpMerchantSyncCartSessionToStoreProps) => {
  const { campaignCode, campaignId } = args
  const { syncCartStoreFromSession } = useFpB2bCartService(campaignId, Platform.MERCHANT)
  const { hasFinishedSyncCartSession, setHasFinishedSyncCartSession } = useFpMerchantSyncCartSessionStore()
  /**
  * 為了達成不同devices間sync cart內容，使用useApiFpCartRequestCache 從後端取得內容。僅在component mount時取得一次 (isImmutable = true)
  * 此cart 內容即為calculate api 中帶往後端的cart_values
  * 已同步過就不再拉：PDF 加入購物車後前端直接改寫本機並標成已同步，session 裡可能還是舊快照，再拉會把本機蓋掉
  */
  useApiFpCartRequestCache(hasFinishedSyncCartSession ? null : campaignCode ?? null, {
    shouldRetryOnError: false,
    onError: () => {
      setHasFinishedSyncCartSession(true)
    },
    onSuccess: (data) => {
      const cache = data.data.data as CampaignCalculateRequest<FpB2bCartValues> | null
      syncCartStoreFromSession({
        cartValues: cache?.cart_values,
        orderItems: cache?.order_items,
        callback: () => {
          setHasFinishedSyncCartSession(true)
        },
      })
    },
  })

  return { hasFinishedSyncCartSession }
}
